// makes all line breaks consistent so that papaparse can parse the file correctly
export function normalizeLineEndings(text) {
  return text.replace(/\r\n|\r/g, '\n');
}

// Classifies one parsed CSV record into a code/label pair plus validity info.
// A code is invalid if it's blank, its label is blank, or it contains a
// space/underscore.
function classifyRow(rawCode, rawLabel) {
  const code = (rawCode || '').trim().toLowerCase();
  const label = (rawLabel || '').trim();

  if (!code) return { code, label, reason: 'missing code' };
  if (!label) return { code, label, reason: 'missing label' };
  if (/[\s_]/.test(code)) return { code, label, reason: 'Invalid characters, underscores and spaces are not allowed.' };
  return { code, label, reason: null };
}

// returns one preview row per record with a status ('new' | 'overwrite' | 'duplicate' | 'invalid')
function buildAudiencePreviewRows(parsedRecords, existingValues) {
  const classified = parsedRecords.map((record) => classifyRow(
    record.Abbreviation,
    record['Full Name'],
  ));

  const codeCounts = {};
  classified.forEach(({ code, reason }) => {
    if (reason) return;
    codeCounts[code] = (codeCounts[code] || 0) + 1;
  });

  return classified.map(({ code, label, reason }) => {
    // if the code is invalid, return it with the reason and status
    if (reason) {
      return {
        code, label, reason, status: 'invalid', checked: false,
      };
    }
    // if there is a duplicate code in the CSV, return it with status 'duplicate'
    if (codeCounts[code] > 1) {
      return {
        code, label, reason: null, status: 'duplicate', checked: true,
      };
    }
    // if the code already exists in the client's audience values, return it with status 'overwrite'
    if (Object.prototype.hasOwnProperty.call(existingValues, code)) {
      return {
        code, label, reason: null, status: 'overwrite', checked: true,
      };
    }
    return {
      code, label, reason: null, status: 'new', checked: true,
    };
  });
}

export default buildAudiencePreviewRows;
